<template>
  <div class="header">
    <h3 class="header__items__item__heading d-flex d-md-none" v-if="currentRoute"
      >{{ currentRoute.order + 1 }}. {{ $t(currentRoute.heading) }}
    </h3>
    <h3 class="header__items__item__heading d-flex d-md-none" v-else>3. {{ headerItems[2].heading }} </h3>
    <div class="header__items">
      <div class="header__items__item" v-for="(headerItem, index) in headerItems" :key="index">
        <template v-if="headerItem.showInHeader">
          <h3
            tabindex="-1"
            :aria-hidden="currentRoute !== headerItem"
            class="header__items__item__heading d-none d-md-flex"
            :id="`headerItem${index}`"
            >{{ headerItem.order + 1 }}. {{ $t(headerItem.heading) }}
          </h3>

          <div
            class="header__items__item__border"
            :class="[
              {
                'header__items__item__border--success':
                  $route.name == 'ConfirmedView' || (currentRoute && currentRoute.order > index),
              },
              { 'header__items__item__border--active': currentRoute && headerItem.name == currentRoute.name },
            ]"
          ></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      headerItems: [
        { name: 'BookingView', heading: 'Meeting details', order: 0, showInHeader: true },
        { name: 'PersonalView', heading: 'Contact information', order: 1, showInHeader: true },
        { name: 'ConfirmationView', heading: 'Confirmation', order: 2, showInHeader: true },
      ],
      activeRoute: {},
    }
  },
  computed: {
    currentRoute() {
      return this.headerItems.find((el) => el.name == this.$route.name)
    },
  },
  watch: {
    $route(val) {
      if (val.name == 'BookingView') {
        document.getElementById(`headerItem0`).focus()
      } else if (val.name == 'PersonalView') {
        document.getElementById(`headerItem1`).focus()
      } else if (val.name == 'ConfirmationView') {
        document.getElementById(`headerItem2`).focus()
      }
    },
  },
}
</script>
